module.exports = __webpack_public_path__ + "static/sleeping-cat3-fb88d0473fecde5b774ca4126d20fec4.gif";